module.exports = __webpack_public_path__ + "assets/img/list_sukikamo_sp.8917b0ab.svg";